import { getRouteApi } from '@tanstack/react-router';
import * as React from 'react';

import { ParametersScreen } from '@/routes/parameters/parameters-screen';

// =============================================================================
// parameters-route.tsx — Adaptateur routeur de l'écran A-24.
// =============================================================================
// Lie l'état d'URL (search param `param`, TanStack Router) au composant de
// présentation `ParametersScreen`. La sélection vit dans l'URL (RULE_REF_006 :
// pas de localStorage) : navigation, partage de lien et bouton retour cohérents.

const routeApi = getRouteApi('/parameters');

export function ParametersRoute(): React.JSX.Element {
  const search = routeApi.useSearch();
  const navigate = routeApi.useNavigate();

  const selectedKey = search.param ?? null;

  const onSelect = React.useCallback(
    (paramKey: string | null): void => {
      void navigate({
        search: paramKey === null ? {} : { param: paramKey },
      });
    },
    [navigate],
  );

  return <ParametersScreen selectedKey={selectedKey} onSelect={onSelect} />;
}
